import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { TextInput } from './TextInput';
export const FileInput = ({ className, ...props }) => {
    return _jsx(TextInput, { className: classNames('!p-0', className), ...props, type: "file" });
};
